<template>
  <el-form
    :model="modelValue"
    :rules="formRules"
    ref="subuserForm"
    label-position="top"
  >

    <el-form-item prop="role" label="Роль" v-show="!modelValue.editMode || !editingUserIsPrimary">
      <el-select v-model="modelValue.role" style="width: 100%" data-test="roleSelect">
        <el-option
            v-for="(role, i) in modelValue.roles"
            :key="i"
            :label="role.title"
            :value="role._id"
        />
      </el-select>
    </el-form-item>

    <el-form-item prop="surname" label="Фамилия">
      <el-input v-model="modelValue.surname" data-test="userSurname"/>
    </el-form-item>

    <el-form-item prop="name" label="Имя">
      <el-input v-model="modelValue.name" data-test="userName"/>
    </el-form-item>

    <el-form-item prop="patronymic" label="Отчество">
      <el-input v-model="modelValue.patronymic" data-test="userPatronymic"/>
    </el-form-item>

    <el-form-item prop="phone" label="Телефон">
      <el-input v-model="modelValue.phone" data-test="userPhone"/>
    </el-form-item>

    <el-form-item prop="email" label="E-mail">
      <el-input v-model="modelValue.email" data-test="userEmail"/>
    </el-form-item>

    <el-divider v-show="modelValue.editMode"></el-divider>
    <el-button text v-show="modelValue.editMode" @click="showPasswordFields = !showPasswordFields"
                style="margin-bottom: 22px">Сменить пароль
    </el-button>
    <div v-show="showPasswordFields || !modelValue.editMode">

      <el-form-item prop="password" label="Пароль">
        <el-input v-model="modelValue.password" type="password" show-password
                  placeholder="**************" data-test="userPassword">
          <template #append>
            <el-button @click="autogeneratePassword">Сгенерировать</el-button>
          </template>
        </el-input>
      </el-form-item>

      <el-form-item prop="passwordConfirm" label="Подтвердите пароль">
        <el-input v-model="modelValue.passwordConfirm" type="password" show-password
                  placeholder="**************" data-test="userPasswordConfirm"/>
      </el-form-item>

      <!--              <el-form-item label="Выслать учётную запись">-->
      <!--                <el-checkbox-group v-model="sendProfileBy">-->
      <!--                  <el-checkbox label="email">по E-mail</el-checkbox>-->
      <!--                  <el-checkbox label="sms">по СМС</el-checkbox>-->
      <!--                </el-checkbox-group>-->
      <!--              </el-form-item>-->
      
    </div>
  </el-form>
</template>

<script>
export default {
  name: "SubuserEditForm",
  props: ["modelValue"],
  expose: ["resetPasswordFields", "validate"],
  computed: {
    editingUserIsPrimary() {
      return this.modelValue.editMode && this.modelValue.system_id.split(".").length === 1
    },
    formRules() {
      return {
        role: [{required: !this.editingUserIsPrimary, message: "Это поле обязательно к заполнению", trigger: "change"}],
        phone: [{
          required: true,
          message: "Неверный номер телефона",
          trigger: 'change',
          validator: (_, value) => validatePhone(patchPhone(value))
        }],
        email: [{required: true, message: "Неверный E-mail адрес", trigger: 'change', type: 'email'}],
        surname: [{required: true, message: "Это поле обязательно к заполнению", trigger: 'change'}],
        name: [{required: true, message: "Это поле обязательно к заполнению", trigger: 'change'}],
        patronymic: [{required: true, message: "Это поле обязательно к заполнению", trigger: 'change'}],
        password: [
          {
            required: (this.showPasswordFields || !this.modelValue.editMode) ? true : false,
            message: "Пароль должен содержать минимум 8 символов, одну заглавную букву, одну строчную, цифру и спецсимвол",
            trigger: 'change',
            validator: this.passwordOk
          }
        ],
        passwordConfirm: [
          {
            required: (this.showPasswordFields || !this.modelValue.editMode) ? true : false,
            message: "Пароли не совпадают",
            trigger: 'change',
            validator: this.validatePasswordMatch
          },
        ]
      }
    }
  },
  methods: {
    resetPasswordFields(){
      this.showPasswordFields = false
    },
    async validate(){
      try {
        return await this.$refs.subuserForm.validate()
      } catch {
        return false
      }
    },
    autogeneratePassword() {
      let digits = "0123456789"
      let chars = "abcdefghijklmnopqrstuvwxyz"
      let spec = "!@#$%^&*()_"
      let rV = (a) => a[Math.floor(Math.random() * a.length)]
      let pwd = [
          rV(digits),
          rV(digits),
          rV(chars),
          rV(chars),
          rV(chars),
          rV(chars),
          rV(chars),
          rV(chars.toUpperCase()),
          rV(chars.toUpperCase()),
          rV(chars.toUpperCase()),
          rV(spec),
          rV(spec)
      ].map(value => ({ value, sort: Math.random() }))
          .sort((a, b) => a.sort - b.sort)
          .map(({ value }) => value).join("")

      // let pwd = Math.random().toString(36).slice(2, 16)
      this.modelValue.password = String(pwd)
      this.modelValue.passwordConfirm = String(pwd)
    },
    validatePasswordMatch(_, value) {
      return value === this.modelValue.password
    },
    passwordOk(_, value){
      if (this.modelValue.editMode && !this.showPasswordFields){return true}
      else {return value.trim().length >= 8 && /(?=(.*[0-9]){1,})(?=(.*[a-zа-яё]){1,})(?=(.*[A-ZА-ЯЁ]){1,})(?=(.*[^0-9a-zа-яёA-ZА-ЯЁ]){1,})/.test(value)}
    },
  },
  data(){
    return {
      showPasswordFields: false
    }
  }
}
</script>